import $ from 'jquery';
import { native_players, nativePlayerInit } from './nativePlayer';
import { youtube_players, youtubePlayerInit } from './youtubePlayer';
import { vimeo_players, vimeoPlayerInit } from './vimeoPlayer';

const native_timestamps = {};
const youtube_timestamps = {};

export default function() {
  $(document).on('shopify:section:unload', (e) => {
    const section_id = e.detail.sectionId;
    const $section = $(`[data-section-id="${section_id}"]`);

    $section.find('[data-background-video]').each((i, container) => {
      const $container = $(container);
      const player_id = $($container).find('[data-video-player]').attr('id');
      const type = $container.data('videoType');

      if (type === 'youtube') {
        // We need to save the start time so we can resume when we reinit everything.
        // We save it to an object because getCurrentTime may not always be available if you're making rapid changes
        // and the youtube player was recently destroyed and hasn't had a chance to start up and buffer again yet.
        if (youtube_players[player_id].getCurrentTime) {
          youtube_timestamps[player_id] = Math.floor(youtube_players[player_id].getCurrentTime());
        }

        youtube_players[player_id].destroy();
        return delete youtube_players[player_id];
      }

      if (type === 'vimeo') {
        vimeo_players[player_id].destroy();
        return delete vimeo_players[player_id];
      }

      if (native_players[player_id]) {
        native_timestamps[player_id] = native_players[player_id].currentTime;
        return delete native_players[player_id];
      }

      return false;
    });

  });

  $(document).on('shopify:section:load', (e) => {
    const section_id = e.detail.sectionId;
    const $section = $(`[data-section-id="${section_id}"]`);

    $section.find('[data-background-video]').each((i, container) => {
      const $container = $(container);
      const player_id = $($container).find('[data-video-player]').attr('id');
      const type = $container.data('videoType');

      if (type === 'youtube') {
        const start = youtube_timestamps[player_id] || 0;
        return youtubePlayerInit($container, start);
      }

      if (type === 'vimeo') {
        return vimeoPlayerInit($container);
      }

      const start = native_timestamps[player_id] || 0;
      return nativePlayerInit($container, start);
    });
  });
}